import React from "react";
import ModalBoxCore from "../../../core-components/modal-box/ModalBoxCore";
import ModalBody from "../../../core-components/modal-box/modal-body/ModalBody";
import PhotoLibrary from "../../../pages-components/photo-library/PhotoLibrary";
import { IPhotoLibraryPhoto } from "../../../../interfaces/photoLibrary";
import { IAttachmentFile } from "../../../../interfaces/corporateEvent";
import "./photoLibraryModal.scss";

interface IAddQuoteImagesModalProps {
	open: boolean;
	selectedAttachments: IAttachmentFile[];
	onClose: () => void;
	triggerPreviewPhoto: (photo: IPhotoLibraryPhoto | null) => void;
	onAttachmentsChange: (attachments: IAttachmentFile[]) => void;
}

const AddQuoteImagesModal: React.FC<IAddQuoteImagesModalProps> = ({
	open,
	selectedAttachments,
	onClose,
	triggerPreviewPhoto,
	onAttachmentsChange,
}) => {
	return (
		<ModalBoxCore className="photoLibraryModal" open={open} onClose={onClose}>
			<ModalBody>
				<PhotoLibrary
					selectedAttachments={selectedAttachments}
					triggerPreviewPhoto={triggerPreviewPhoto}
					onClose={onClose}
					onAttachmentsChange={onAttachmentsChange}
				/>
			</ModalBody>
		</ModalBoxCore>
	);
};

export default AddQuoteImagesModal;
